/**************************************************
 * Nombre:       Seccion_Capacitaciones
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, LinearProgress, Typography} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {theme} from "../../Tema";
import {Box} from "@mui/system";
import Tarjeta_Capacitaciones from "../Tarjetas/Tarjeta_Capacitaciones";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../Servicios/BD/obtenerColWheres";
import {usuarioContext} from "../../App";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Historia from "../Dialogos/Dialogo_Historia";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import {verificarObligatorias} from "../../CodigoNegocio/Capacitaciones/verificarObligatorias";
import {useParams} from "react-router-dom";
import {scrolearAComponente} from "../../Utilidades/scrolearAComponente";


const Seccion_Capacitaciones = () => {
    const cData = useContext(usuarioContext)
    const {sCell, sTab} = useResponsive()
    const parms = useParams()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Historia, titulo: "Cuentanos tu historia"})
    const [capacitaciones, setCapacitaciones] = useState([]);
    const [capacitacionObligatorias, setCapacitacionObligatorias] = useState([]);
    const [calificaciones, setCalificaciones] = useState([]);
    const [obligatoriasHechas, setObligatoriasHechas] = useState(false);
    const [idEscogido, setIdEscogido] = useState('');


    useEffect(() => {
        let w = [where('estado', '==', 'Publicado')]
        obtenerColWheres({col: 'capacitaciones', wheres: w}).then((dox) => {

            let arrObligatorias = dox.data.filter(dox => dox.obigatoria === 'Si')
            let arrCapacitacion = dox.data.filter(dox => dox.obigatoria === 'No' || dox.obigatoria === undefined)
            setCapacitaciones(arrCapacitacion)
            setCapacitacionObligatorias(arrObligatorias)

            console.log(arrObligatorias)

            let wCal = [where('idUsuario', '==', cData.usuario.id)]
            obtenerColWheres({col: 'calificaciones', wheres: wCal}).then((des) => {
                if (dox.data) {
                    setCalificaciones(des.data);
                    setObligatoriasHechas(verificarObligatorias(des.data, arrObligatorias))
                }
            })

        })


    }, [cData.usuario]);

    useEffect(() => {

        if (parms && parms.id) {
            setIdEscogido(parms.id);
        }

    }, [parms]);
    return (

        <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1200px', pb: 6}}
                spacing={0}
                onLoad={() => {

                    if (idEscogido) {
                        scrolearAComponente(idEscogido)
                    }

                }
                }
            >

                <Dialogo/>

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 7, md: 8}} sx={{justifyContent: 'flex-start'}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                    <Typography sx={{
                                        color: theme.palette.primary.main,
                                        fontSize: sCell ? 32 : 36,
                                        fontWeight: 800,
                                        lineHeight: 1.1
                                    }}>
                                        Capacitaciones Disponibles
                                    </Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 9}}
                                      sx={{justifyContent: 'flex-start', mt: sCell ? 1.5 : 0}}>
                                    <Typography sx={{fontSize: 14, fontWeight: 400}}>
                                        Accede a las capacitaciones diseñadas para impulsar tu desarrollo y avanzar paso
                                        a paso hacia el éxito empresarial.
                                    </Typography>
                                </Grid>

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 6}}
                                >

                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 2}}>
                                        <Typography sx={{
                                            color: '#545454', fontSize: 16, fontWeight: 700,
                                        }}>{`${obligatoriasHechas}% `}
                                            <span
                                                style={{fontWeight: 600}}>En tests obligatorios</span>
                                        </Typography>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 10}}
                                          sx={{justifyContent: 'flex-start', mt: 0.5}}>
                                        <Box sx={{width: '100%'}}>
                                            <LinearProgress variant="determinate"
                                                            value={obligatoriasHechas}
                                                            sx={{height: 16}}/>
                                        </Box>
                                    </Grid>

                                </Grid>


                            </Grid>
                        </Grid>


                    </Grid>
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'center', px: sCell ? 6 : 0, mt: sCell ? 2 : 8}}>
                    <Typography sx={{
                        //  color: '#00000090',
                        fontSize: 32,
                        fontWeight: 800,
                        lineHeight: 1,
                        textAlign: 'center'
                    }}>
                        Tu primer paso es ser consultor
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'center', px: sCell ? 0 : 6, mt: 0.8}}>
                    <Typography sx={{
                        // color: theme.palette.primary.main,
                        fontSize: 16,
                        fontWeight: 400,
                        lineHeight: 1.1,
                        textAlign: 'center'
                    }}>
                        Comienza tu camino hacia el éxito formándote como consultor del Team Tufiño.
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'flex-start', mt: sCell ? 6 : 12, px: sCell ? 0 : 4}}>
                    <Grid
                        container
                        direction={'row-reverse'}
                        justifyContent={'flex-start'}
                        alignItems={'flex-end'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={sTab ? 4 : 10}
                    >

                        <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>

                            {obligatoriasHechas >= 100 &&

                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{
                                        backgroundColor: theme.palette.primary.main,
                                        borderRadius: 4,
                                        color: '#fff',
                                        p: 4
                                    }}
                                    spacing={0}
                                >

                                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                        <Typography sx={{fontSize: 32, fontWeight: 800, lineHeight: 1.1}}>Felicidades
                                            Eres Un Consultor!!!</Typography>
                                    </Grid>

                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 1}}>
                                        <Typography sx={{fontSize: 16, fontWeight: 400, lineHeight: 1.3}}>
                                            Has completado la capacitación base y ahora formas parte del grupo de
                                            consultores del Team Tufiño. Este es solo el comienzo de un camino lleno de
                                            crecimiento y éxito.
                                        </Typography>
                                    </Grid>


                                </Grid>
                            }

                        </Grid>

                        {capacitacionObligatorias.map((it, index) => (
                            <Grid id={it.id} container size={{xs: 12, sm: 6, md: 6}}
                                  sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Capacitaciones item={it} escogida={idEscogido} calificaciones={calificaciones}
                                                        disponibles={true}/>
                            </Grid>
                        ))}


                    </Grid>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'flex-start', px: sCell ? 3 : 6, mt: 8}}>
                    <Typography sx={{
                        color: theme.palette.primary.main,
                        fontSize: 24,
                        fontWeight: 800,
                        lineHeight: 1.1,
                        textAlign: sCell ? 'center' : 'left'
                    }}>
                        Capacitaciones adicionales
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'flex-start', px: sCell ? 3 : 6, mt: 0}}>
                    <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'flex-start', mt: 1}}>
                        <Typography sx={{
                            fontSize: 18,
                            fontWeight: 300,
                            lineHeight: 1.1,
                            textAlign: sCell ? 'center' : 'left'
                        }}>
                            Finaliza las capacitaciones obligatorias y obtene el acceso a todas las demas capacitaciones
                        </Typography>
                    </Grid>

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}
                      sx={{justifyContent: 'flex-start', mt: sCell ? 8 : 12, px: sCell ? 0 : 4}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-end'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={sTab ? 4 : 10}
                    >

                        {capacitaciones.map((it, index) => (
                            <Grid id={it.id} container size={{xs: 12, sm: 6, md: 6}}
                                  sx={{justifyContent: 'flex-start'}}>
                                <Tarjeta_Capacitaciones escogida={idEscogido} item={it} calificaciones={calificaciones}
                                                        disponibles={obligatoriasHechas >= 100}/>
                            </Grid>
                        ))}

                    </Grid>
                </Grid>

                {/*} <PDFViewer style={{width: '100%', height: 520}}>
                    <Pdf_Certificado_Consultor usuario={cData.usuario} capacitacion={{nombre: 'Nuevo consultor'}}/>
                </PDFViewer> */}


            </Grid>

        </Grid>
    )

}
export default Seccion_Capacitaciones

